module.exports = __webpack_public_path__ + "img/xr_6dof.a8b564fd.jpg";